import styled, {css} from "styled-components";

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : Estilos RegisterModalPage
Description : Se definen estilos de los elemenos de la vista del formulario.
Date Autor Modification
================================================================================
30/09/2021 Santiago Coca Rojas Creación – Se definene estilos y elementos de la vista del formulario.
================================================================================ */

export const DivRow = styled.div`
    align-self: center;
    align-content: center;
    justify-self: center;
    justify-content: center;
    background-color: #3498DB;
`;

export const Form = styled.div`
    display: flex;
    align-content: center;
    justify-content: center;
`;
